import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { PanelContent, PanelWhite } from '../../../components/Layout/styles';
import { LeafletMap } from '../../../components/LeafletMap/LeafletMap';
import { MapMarkers } from '../../../components/LeafletMap/components/MapMarkers';
import { Offer } from '../../../models/offers.model';

const StyledMap = styled(LeafletMap)`
  height: 30vh;
`;

interface Props {
  offer: Offer;
}
export const OfferLocation: React.FC<Props> = ({ offer }) => {
  const { t } = useTranslation();
  return (
    <PanelWhite header={t('LOCALIZATION')} collapsible bodyFill defaultExpanded>
      <PanelContent>
        <StyledMap>
          <MapMarkers offerData={[offer]} selectedOfferId={offer.id} disableAnimation />
        </StyledMap>
      </PanelContent>
    </PanelWhite>
  );
};
